import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailibilityService } from 'src/app/services/availibility.service';
import { BankHolidaysService } from 'src/app/services/bank-holidays.service';
import { DataStoreService } from '../../services/data-store.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CalendarComponent implements OnChanges, OnInit {
  @Output() slotsLength = new EventEmitter<Number>();
  @Output() loadIssue = new EventEmitter<boolean>();
  @Input() service: any;
  @Input() requiredAvailability: any;
  @ViewChild('calendar', { static: true }) calendar: MatCalendar<Date>;
  @Output() notBookableCheck = new EventEmitter<boolean>();
  @Input() tempBasket: any;
  @Output() onSelectDate = new EventEmitter<boolean>();
  @Input() dateLimit: Date;
  @Output() slotsCheck = new EventEmitter<boolean>();

  constructor(
    private DataStore: DataStoreService,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef,
    private bankHolidayService: BankHolidaysService,
    private availabilityService: AvailibilityService
  ) { }

  // Set max date as yesterday so the user cannot select a date until
  minDate = new Date(this.DataStore.selectedService.min_advance_datetime);
  maxDate = new Date(this.DataStore.selectedService.max_advance_datetime);

  unavailableSlots: any;
  availableSlots: any;
  // this is for highlights
  selectedDates = [];
  // slots to show on FR
  presentendSlots = [];
  // selected slots to be accessed by parent compo 
  selectedSlots = []

  calendarReady = false;
  currentDate: any;
  alreadyRan = false;
  slots: any;
  selectedDate: Date;
  selectedD: any;

  loadCalendar: boolean;
  availableDays: any;
  selectedService;
  collectionDate: Date;
  notBookable: boolean;
  freeDays = true;
  alreadySelected = false;

  ngOnChanges() {
    if (this.alreadyRan) {
      this.currentDate = new Date();
      if (this.DataStore.selectedService) {
        this.calendarFunction();
        this.unavailableDates;
      }
    }
  }

  async ngOnInit() {
    if (!this.alreadyRan) {
      this.currentDate = new Date();
      this.selectedDate = this.currentDate;
      if (this.DataStore.selectedService) {
        this.spinner.show();
        this.alreadyRan = true;
        this.calendarFunction();
      }
    }
  }

  async calendarFunction() {
    const serviceAvailibility = this.DataStore.servicesAvailibility.filter(service => service.serviceid == this.DataStore.selectedService.id);

    if (serviceAvailibility.length > 0) {
      this.availableDays = serviceAvailibility[0].days;

      // remove weekends from available days 
      this.availableDays = this.availableDays.filter(day => new Date(day.date).getDay() !== 0 && new Date(day.date).getDay() !== 6);
      // exclude days that don't have enough slots
      let applicantsCount = this.DataStore.applicationDetails.length;
      this.availableDays = this.availableDays.filter(day => day.spaces >= applicantsCount);

      new Promise((resolve, reject) => {
        // Check for holiday dates in our available days
        if (this.DataStore.selectedLocation.id === 37001 || this.DataStore.selectedLocation.id === 37002) {
          this.bankHolidayService.getIrelandsBankHolidays().then(res => {
            const holidayDays = res.map(holidays => { return new Date(holidays.date.iso).toDateString() });
            this.availableDays.forEach((availDays, index) => {
              const found = holidayDays.includes(new Date(availDays.date).toDateString());
              if (found) {
                this.availableDays.splice(index, 1);
              }
            });
            // refresh calendar
            this.calendar.updateTodaysDate();
            resolve('holidays done');
          }, (err) => {
            this.loadIssue.emit(true);
            this.spinner.hide();
            reject(err);
          });
        } else {
          this.bankHolidayService.getUKBankHolidays().then(res => {
            const holidayDays = res.map(holidays => { return new Date(holidays.date.iso).toDateString() });
            this.availableDays.forEach((availDays, index) => {
              const found = holidayDays.includes(new Date(availDays.date).toDateString());
              if (found) {
                this.availableDays.splice(index, 1);
              }
            });
            // refresh calendar
            this.calendar.updateTodaysDate();
            resolve('holidays done');
          }, (err) => {
            this.loadIssue.emit(true);
            this.spinner.hide();
            reject(err);
          });
        }
      }).then(() => {
        // If the same day service is selected then only return the first three items in the array
        if (serviceAvailibility[0].serviceid === '48320') {
          this.availableDays = this.availableDays.slice(0, 3);
        }
        // remove empty days after we slice the amount we need
        this.availableDays = this.availableDays.filter((day) => day.spaces > 0);


        // if there are no available days, there are no slots on this service at all
        if (this.availableDays && this.availableDays.length == 0) {
          this.notBookableCheck.emit(true);
          this.notBookable = true;
        } else {
          this.notBookableCheck.emit(false);
          this.notBookable = false;
        }

        if (this.availableDays && this.availableDays.length >= 1) {
          this.updateSlots(new Date(this.availableDays[0].date));
        } else {
          this.updateSlots(new Date());
        }

        this.calendar.updateTodaysDate();
      });
    }
  }

  async getSlots(date) {
    const params = {
      'company_id': this.DataStore.selectedLocation.id,
      'service_id': this.DataStore.selectedService.id,
      'start_date': date,
      'end_date': date
    };

    let groupedSlots;

    try {
      const baseResource = await this.DataStore.selectedLocation.$get('times', params)
      const slots = baseResource.times;

      groupedSlots = await _.groupBy(slots, slot => slot.start.split('T')[0]);
    } catch (error) {
      this.notBookableCheck.emit(true);
      this.notBookable = true;
      this.freeDays = false;
      this.spinner.hide();
      this.ref.detectChanges();
    }
    return groupedSlots;
  }

  unavailableDates = (date: Date): boolean => {
    const momentDate = moment(date);

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // Calculate the next business day (skip weekends)
    const nextBusinessDay = new Date(today);
    nextBusinessDay.setDate(today.getDate() + 1);
    while (nextBusinessDay.getDay() === 0 || nextBusinessDay.getDay() === 6) {
      nextBusinessDay.setDate(nextBusinessDay.getDate() + 1);
    }

    const isToday = moment(date).isSame(today, 'day');
    const isNextBusinessDay = moment(date).isSame(nextBusinessDay, 'day');

    const pastTenAM = now.getHours() > 10 || (now.getHours() === 10 && now.getMinutes() > 0);

    const selectedServiceId = this.DataStore.selectedService?.id;

    if (
      selectedServiceId !== 48320 &&
      (isToday || isNextBusinessDay) &&
      pastTenAM
    ) {
      return false;
    }

    // SUP-2459: Block the upcoming Monday for the Four-Day service (48321 Dublin / 48322 Cork)
    // from 10am Friday until 6pm Monday, so the earliest bookable day is the following Tuesday.
    // Fills the Sat/Sun/Mon-before-10am gap the generic 10am rule above misses; only ever blocks.
    // Full day/time -> outcome table: docs/SUP-2459-four-day-weekend-lockdown.md
    const fourDayServiceIds = [48321, 48322];
    const dayOfWeek = now.getDay(); // 0 = Sunday ... 6 = Saturday

    // Work out which Monday (if any) is currently inside the lockdown window.
    let weekendLockoutMonday: Date | null = null;
    if (dayOfWeek === 5 && pastTenAM) {
      // Friday from 10am onwards -> lock the Monday three days ahead.
      weekendLockoutMonday = new Date(today);
      weekendLockoutMonday.setDate(today.getDate() + 3);
    } else if (dayOfWeek === 6) {
      // Saturday -> lock the Monday two days ahead.
      weekendLockoutMonday = new Date(today);
      weekendLockoutMonday.setDate(today.getDate() + 2);
    } else if (dayOfWeek === 0) {
      // Sunday -> lock the Monday one day ahead.
      weekendLockoutMonday = new Date(today);
      weekendLockoutMonday.setDate(today.getDate() + 1);
    } else if (dayOfWeek === 1 && now.getHours() < 18) {
      // Monday before 6pm -> lock today (this Monday).
      weekendLockoutMonday = new Date(today);
    }

    // Block the locked Monday (and any earlier day, e.g. the weekend itself) for Four-Day.
    if (
      fourDayServiceIds.includes(selectedServiceId) &&
      weekendLockoutMonday &&
      momentDate.isSameOrBefore(weekendLockoutMonday, 'day')
    ) {
      return false;
    }

    // Normal availability
    return this.availableDays
      ? this.availableDays.some(day => momentDate.isSame(day.date, 'day'))
      : false;
  };



  removeDate(slot) {
    const index: number = this.selectedSlots.indexOf(slot);
    if (index !== -1) {
      this.selectedSlots.splice(index, 1);
    }
    this.slotsLength.emit(this.selectedSlots.length);
  }

  selectSlot(slot) {

    // Check if the users selected slots are still valid (not in the past). If the selected slot is 
    // now in the past then display error message and stop them from proceeding
    const now = new Date();
    const selectedStart = new Date(slot.start);
    if (now >= selectedStart) {
      this.slotsCheck.emit(true);
    } else {
      this.slotsCheck.emit(false);
    }

    const index: number = this.selectedSlots.indexOf(slot);

    if (index !== -1) {
      // Clicked on already selected slot
      this.selectedSlots.splice(index, 1);
    } else {
      // If slot length is not full, add this slot
      if (this.selectedSlots.length != this.requiredAvailability) {
        this.selectedSlots.push(slot);
      } else {
        // slot length is full, slice the first one
        this.selectedSlots.shift();
        // and push the new selected one
        this.selectedSlots.push(slot)
      }
    }
    this.slotsLength.emit(this.selectedSlots.length);
  }

  async addBusinessDays(d, n) {
    const tempDate = d;
    d = new Date(d.getTime());
    var day = d.getDay();

    const tempCollection = new Date(d.getTime());
    var day = d.getDay();
    tempCollection.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));

    // Checks if any bank holidays in IE or UK fall in the collection date and if so for every bank holiday
    // that is included in the collection date then add a day if not a weekend
    if (this.bankHolidayService.irelandBankHolidays) {
      for (const holiday of Array.from(this.bankHolidayService.irelandBankHolidays)) {
        const holidayDate = new Date(holiday['date'].iso);
        const holidayName = holiday['name'];
        holidayDate.setHours(0, 0, 0, 0);
        if (holidayName.includes('Solstice') || holidayName.includes('Equinox')) {
        } else {
          if (holidayDate >= tempDate && holidayDate <= tempCollection) {
            n++;
          }
        }
      }
      d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
      this.collectionDate = d;
      this.ref.detectChanges();
    } else if (this.bankHolidayService.londonBankHolidays) {
      for (const holiday of Array.from(this.bankHolidayService.londonBankHolidays)) {
        const holidayDate = new Date(holiday['date']);
        holidayDate.setHours(0, 0, 0, 0);
        if (holidayDate >= tempDate && holidayDate <= tempCollection) {
          n++;
        }
      }
      d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
      this.collectionDate = d;
      this.ref.detectChanges();
    }
  }

  // Date selected on calendar
  async updateSlots(date) {
    // AUTO-JUMP if selected date becomes unavailable
    const isAllowed = this.unavailableDates(date);

    if (!isAllowed) {
      const nextValid = this.availableDays
        ?.map(d => new Date(d.date))
        .sort((a, b) => a.getTime() - b.getTime())
        .find(d => this.unavailableDates(d) === true);

      if (nextValid) {
        this.selectedDate = nextValid;
        this.calendar.selected = nextValid;
        return this.updateSlots(nextValid); // recall
      }

      // If nothing available
      this.selectedDate = null;
      this.calendar.selected = null;
      return;
    }

    this.selectedSlots.length = 0;
    this.spinner.show();

    // Set date to the one in basket
    if (this.tempBasket.length >= 1 && !this.alreadySelected && this.DataStore.selectedService.id === this.tempBasket[0].service_id) {
      date = new Date(this.tempBasket[0].start);
    }

    // Add the timezone offset to fix date issues
    // Use the selected date's offset (not today's) to handle DST boundaries correctly
    const tzoffset = date.getTimezoneOffset() * 60000;
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1).split('T')[0];
    const localTimeStamp = new Date();

    this.getSlots(localISOTime).then(slots => {
      this.slots = slots;
      if (this.slots) {
        const self = this;
        self.selectedDate = date;
        self.selectedD = date;

        // Calculate the collection date
        if (self.DataStore.service.name.includes('Four')) {
          self.addBusinessDays(self.selectedDate, 3);
        } else if (self.DataStore.service.name.includes('Five')) {
          self.addBusinessDays(self.selectedDate, 4);
        }

        if (self.slots[localISOTime]) {
          self.presentendSlots = self.slots[localISOTime]

          self.presentendSlots = self.presentendSlots.filter(slot => slot.available == true);
          // Filter out times slots from before now 
          self.presentendSlots = self.presentendSlots.filter(slot => new Date(slot.start) > localTimeStamp);

          // If the user has come back, repopulate the date and time on the calendar  
          let alreadySelectedSlots;
          if (this.tempBasket.length >= 1 && !this.alreadySelected) {
            if (this.DataStore.selectedService.id === this.tempBasket[0].service_id && !this.alreadySelected) {
              this.tempBasket.forEach((basket) => {
                alreadySelectedSlots = self.presentendSlots.filter(slot => slot.start == basket.start);
                self.selectedSlots.push(...alreadySelectedSlots.slice(0, self.requiredAvailability));
              });
              this.alreadySelected = true;
            } else {
              this.alreadySelected = true;
              self.selectedSlots.push(...self.presentendSlots.slice(0, self.requiredAvailability));
            }
          } else {

            // if the day is available (eg not a bank hol)
            let cleanedPresentedSlots = [];
            self.presentendSlots.forEach(slots => {
              self.availableDays.forEach(availSlots => {
                if (availSlots.date == slots.start.split("T")[0]) {
                  cleanedPresentedSlots.push(slots);
                }
              });
            });

            // select the first available day from above
            self.selectedSlots.push(...cleanedPresentedSlots.slice(0, self.requiredAvailability));
          }
        } else {
          console.log('no slot data!');
        }
        self.spinner.hide();

        // This ensures selecting a different day that a selected slot is already selected
        this.slotsLength.emit(this.selectedSlots.length);

        // On selecting a new day check if this is over 10 working days as this enables us to show guidence messsage
        // If the seleted date is over 10 days from now then show online application guidence
        let onlineApplicationChannel: boolean;

        // Setting the time of the dat limit to midnight to make sure the full 10 working days are accounted for (IPS-210)
        this.dateLimit.setHours(0, 0, 0, 0);

        if (this.selectedSlots.length >= 1) {
          if (new Date(this.selectedSlots[0].start).toISOString() > this.dateLimit.toISOString()) {
            onlineApplicationChannel = true;
          } else {
            onlineApplicationChannel = false;
          }
        } else {
          onlineApplicationChannel = false;
        }

        this.onSelectDate.emit(onlineApplicationChannel);

        this.ref.detectChanges();
      } else {
        this.spinner.hide();
      }
    });
  }
}
